import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import NewButton from '../../common/components/NewButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, franchiseeId, allowNew, ...rest }) => {
	const columns = [
		{
			header: t('Center_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Center_Territory'),
			accessor: 'territory.name',
			sortable: true
		},
		{
			header: t('Center_ContactPerson'),
			accessor: 'contactPerson'
		},
		{
			header: t('Center_PhoneNumber'),
			accessor: 'phoneNumber'
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <Link to={`/franchisees/${franchiseeId}/centers/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
		}
	];



	return (
		<div>
			<PagedEntitiesList columns={columns} listActions={allowNew && <NewButton newItemPath={`/franchisees/${franchiseeId}/centers/new`} />}{...rest} />
		</div>
	);
};

export default withTranslation()(List);